// CircularProgress is not used as a loader here
// eslint-disable-next-line no-restricted-imports
import { Box, CircularProgress, CircularProgressProps, Typography } from '@mui/material'

export function CircularProgressWithLabel(props: CircularProgressProps & { value?: number }) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress sx={{ color: 'primaryThemeColor.contrastText' }} variant='determinate' {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Typography data-testid='setup-wizard-percentage' variant='body2' sx={{ color: 'primaryThemeColor.contrastText' }}>{`${
          props.value && Math.round(props.value)
        }%`}</Typography>
      </Box>
    </Box>
  )
}
